// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"764fc44a","239":"ca809edf","453":"f2b7663f","732":"6726f485"}[chunkId] + ".chunk.js";
};